import { FieldsType } from '../../../../Types'
import { RenderInputsPropsType } from './Type'

/**
 * @description return a specifique type based on field props
 */
export const renderType = (field: FieldsType): 'number' | 'tel' | undefined => {
  if (field.type === 'number') {
    return 'number'
  }
  if (field.type === 'tel') {
    return 'tel'
  }
  return undefined
}

/**
 * @description return an inputProps object base on field type
 */
export const renderInputsProps = (field: FieldsType): RenderInputsPropsType => {
  if (field.type === 'number') {
    return {
      inputProps: {
        step: 'any',
        min: 0,
      },
      startAdornment: field.startAdornment || undefined,
      endAdornment: field.endAdornment || undefined,
    }
  }
  return {
    endAdornment: field.endAdornment || undefined,
    startAdornment: field.startAdornment || undefined,
  }
}
